// src/components/About/index.js

// Here's how the breadcrumbs/labels work in this component:
// - Label "Address": Begin
// - Label "Vehicle": VehicleEntry
// - Label "Location": Place
// - Label "Services": SimpleServices, Services, Tires, etc (including Account, on signup)
// - Label "Schedule": Schedule, Location, Review, Finished
import { GraphQLClient } from 'graphql-request';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Col, Row } from 'react-materialize';
import MediaQuery from 'react-responsive';
import ReferrerDebugger from './ReferrerDebugger';
import YourCar from './YourCar';
import Zippity from './Zippity';

import {currentPageInfo, isFromQuote, shouldAutoSelectLocation, tracRudderStackkEvent} from '../../helper';
import { hasAccessToken } from '../../brainApi';
import MotorAtttribution from './MotorAttribution';

function breadCrumbClick(pathEnd, index, i) {
  if (index >= i) {
    browserHistory.push(`/pricing/${pathEnd}`);
  }
}
const DESKTOP_BREAKPOINT = 1024;
const openSearch = '#openSearch';

console.log("Referrer:", document.referrer);
console.log("Referrer Policy:", document.querySelector('meta[name="referrer"]')?.content);



const MarketingBanner = React.memo(({ bannerData, z3p_client_name, my_simple_shop_url, addXLToImageUrl, services }) => (
  <MediaQuery minWidth={DESKTOP_BREAKPOINT}>
    {matches => (
      <div
        className="marketing-banner"
        style={{
          backgroundImage: `url(${
            matches ? 
              addXLToImageUrl(bannerData.bannerImage?.src || '') :
              bannerData.bannerImage?.src || ''
            })`
        }}
      >
        <div className="banner-content">
          <div className="banner-text">
            <p className="banner-title">{bannerData.overLineText}</p>
            <p className="banner-subtitle">{bannerData.title}</p>
          </div>
          <div className="banner-action">
            <button
              className="banner-button"
              onClick={() => {

                tracRudderStackkEvent('Shop_now_Banner', {
                  proname: z3p_client_name,
                  description: `User clicked Shop Now Button on Banner`,
                  button_name: 'Shop Now',
                  page_information: {
                    path: currentPageInfo.PATH,
                    url: currentPageInfo.URL,
                    title: document.title,
                    //referrer: 'simpleservice'
                  },
                  
                    context: {
                      page: {
                        title: document.title,
                        url: window.location.href,
                        path: window.location.pathname,
                        referrer: document.referrer || "$direct"
                      }
                    }
                  
                  
                },{
                 
                });
                let url = my_simple_shop_url !== null
                  ? `${my_simple_shop_url}${openSearch}`
                  : `https://simpletire.com/#openSearch`;

                if (services != "") {
                  url = my_simple_shop_url !== null
                    ? `${my_simple_shop_url}?services=${services}${openSearch}`
                    : `https://simpletire.com/?services=${services}#openSearch`;
                }
                // window.open(url, '_blank', 'noopener,noreferrer');
                console.log("-----url----",url)
                window.open(url, '_blank', 'noopener');

              }}>
              {bannerData.link?.label || 'Shop Now'}
            </button>
          </div>
        </div>
      </div>
    )}
  </MediaQuery>
));

const AddressBanner = React.memo(({ z3pConfiguration }) => (
  <div
    className="address-banner"
    style={{
      position: 'relative',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      ...(z3pConfiguration?.installer_image
        ? { backgroundImage: `url(${z3pConfiguration.installer_image})` }
        : { backgroundColor: '#f5f5f5' }),

      borderRadius: '20px',
      overflow: 'hidden',
    }}
  >
    {/* Left-to-right dark gradient overlay */}
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0))',
        zIndex: 1,
      }}
    />

    {/* Foreground content */}
    <div
      style={{
        position: 'relative',
        zIndex: 2,
        padding: '24px',
        maxWidth: '50%', // keep text on left side
      }}
    >
      {z3pConfiguration?.logo && (
        <p className="address-banner-title" style={{ color: 'white', fontSize: 20, fontWeight: 600 }}>
          {z3pConfiguration.customer_facing_name}
        </p>
      )}

      <AddressRow
        icon="/static/img/phone-icon.svg"
        text={z3pConfiguration.call_forwarding_phone_raw}
        type="phone"
      />
      <AddressRow
        icon="/static/img/email-icon.svg"
        text={z3pConfiguration.customer_facing_email}
        type="email"
      />
      <AddressRow
        icon="/static/img/address-icon.svg"
        text={z3pConfiguration.st_full_address}
        type="address"
      />
      {z3pConfiguration?.my_simple_shop_url && (
        <AddressRow
          icon="/static/img/earth-icon.svg"
          text={z3pConfiguration.my_simple_shop_url}
          type="website"
        />
      )}
    </div>
  </div>
));
const AddressRow = ({ icon, text, type }) => {
  const handleClick = () => {
    switch (type) {
      case 'phone':
        window.location.href = `tel:${text}`;
        break;
      case 'email':
        window.location.href = `mailto:${text}`;
        break;
      case 'address':
        const encodedAddress = encodeURIComponent(text);
        window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
        break;
      case 'website':
        window.open(text, '_blank');
        break;
      default:
        break;
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        marginBottom: 12,
      }}
      onClick={handleClick}
    >
      <img
        src={icon}
        alt="icon"
        style={{
          width: 20,
          height: 20,
          marginRight: 16,
          filter: 'brightness(0) invert(1)', // makes dark icons white
        }}
      />
      <span style={{ color: 'white', fontSize: 16 }}>{text}</span>
    </div>
  );
};


class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLocationBreadCrumb: true,
      showVehicleBreadCrumb: false,
      bannerData : null
    };
  }

  fetchCfBannerDataData = (async () => {
    const client = new GraphQLClient(`https://graphql.contentful.com/content/v1/spaces/${process.env.REACT_APP_CONTENTFUL_SPACE_ID}/`, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN}`,
      },
    });
    try {
      const query = `{
        homePageBannerCarousel(id: "${process.env.REACT_APP_CONTENTFUL_BANNER_CAROUSEL_ID}") {
          bannerItemsCollection {
            items {
              overLineText
                title
                bannerImage {
                  src
                }
                link {
                  label
                  link {
                    href
                  }
                }
                contentSegment
                dealEndDate
            }
          }
        }
      }
      `;
      const data = await client.request(query);
      if(data) {
        const bannerData = data?.homePageBannerCarousel?.bannerItemsCollection?.items?.[0];
        this.setState({ bannerData : bannerData });
      }
    } catch (error) {
      console.error(error);
    }
  });

  componentDidMount() {
    // If the only service location is shop or workplace and there is only 1 active client location,
    // do not show the Location breadcrumb since location is auto-selected
    const { clientLocations, z3pConfiguration } = this.props;
    const {
      service_locations: serviceLocations,
      is_skipping_vehicle: isSkippingVehicle,
      skip_simple_services_to: skipSimpleServicesTo,
    } = z3pConfiguration;
    if (shouldAutoSelectLocation(serviceLocations, clientLocations)) {
      this.setState({ showLocationBreadCrumb: false });
    }
    this.setState({ showVehicleBreadCrumb: !isSkippingVehicle });
    this.fetchCfBannerDataData();
  }

  isDesktop = () => (
    <MediaQuery minWidth={DESKTOP_BREAKPOINT}>
      {matches => matches}
    </MediaQuery>
  );

  addXLToImageUrl = (url) => {
    const lastDotIndex = url.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return url; // No file extension found, return the original URL
    }
    return `${url.slice(0, lastDotIndex)  }_XL${  url.slice(lastDotIndex)}`;
  }

  render() {
    const {
      currentStep = 'Services',
      h1,
      hideBreadcrumbs,
      h2,
      referrer,
      cart,
      hideYourCar,
      children,
      onContinue,
      showContinue,
      enableContinue,
      alertText = 'Please fill out all required fields before continuing.',
      showMotorAttribution = false,
      vehicle,
      hideNames,
      z3pConfiguration,
      backText
    } = this.props;
    const { service_locations: serviceLocations, my_simple_shop_url, z3p_client_name } = z3pConfiguration;

    const { showLocationBreadCrumb, showVehicleBreadCrumb } = this.state;
    const hasShopService = serviceLocations.includes('shop');
    // All possible steps are: ['Address', 'Vehicle', 'Location', 'Services', 'Schedule']
    const names = [];

    names.push('Services');
    /* if (!hasAccessToken()) {
      names.push('Account');
    }
    if (hasAccessToken() && !hasShopService) {
      names.push('Address');
    }
    if (hasAccessToken() && showLocationBreadCrumb && hasShopService) {
      names.push('Location');
    }
    if (!isFromQuote(cart) && showVehicleBreadCrumb) {
      names.push('Vehicle');
    } */
    names.push('Schedule');
    // eslint-disable-next-line no-undef
    const { pathname } = window.location;
    const segments = pathname.split('/');
    const currentPath = segments.pop() || '/';
    const currentIndex = names.indexOf(currentStep);
    let cartServices = [];
    if (cart.length !== 0) {
      cart.forEach((service) => {
        cartServices.push(service.service_offering_id);
      });
    }
    cartServices = cartServices.join(",");

    // pathEnd: Convert from human-readable label to URL path ending, e.g. if the user clicks "Location", we open the URL "/pricing/place"
    // abbrBreadcrumb: Convert label to abbreviated breadcrumb (mobile device sizing)
    const labelConversion = {
      Services: {
        pathEnd: 'tires',
        abbrBreadcrumb: 'Select Services',
      },
      /*  Account: {
         pathEnd: 'account',
         abbrBreadcrumb: 'Login',
       },
       Address: {
         pathEnd: 'begin',
         abbrBreadcrumb: 'Address',
       },
       Location: {
         pathEnd: 'place',
         abbrBreadcrumb: 'Select a Location',
       },
       Vehicle: {
         pathEnd: 'vehicle',
         abbrBreadcrumb: 'Select a Vehicle',
       }, */
      Schedule: {
        pathEnd: 'schedule',
        abbrBreadcrumb: 'Select Availability',
      },
    };
    const items = names.map((label, i) => {
      let status = 'active';
      if (i < currentIndex) {
        status = 'completed';
      } else if (i > currentIndex) {
        status = 'disabled';
      }else if(currentPath === 'finished'){
        status = 'completed';
      }
      const { pathEnd } = labelConversion[label];
      const extra =
        status === 'completed' ? <i className="material-icons">done</i> : '';
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <>
          <li
            key={label}
            className={status}
            onClick={() => breadCrumbClick(pathEnd, currentIndex, i)}
          >

            <span className="step-text">{label}</span>

          </li>
          <div className={`node ${status}`} />
        </>
      );
    });
    const {bannerData} = this.state;

    const content = (
      <div className="col m12 r-float">
        <MediaQuery minWidth={301}>
          {(matches) => {
            // If screen width > 300px
            if (matches && !hideNames) {
              return (
                <>
                  {bannerData && (
                    <AddressBanner
                      z3pConfiguration={z3pConfiguration}
                    />
                  )}
                  {hideBreadcrumbs ? (
                    <div className="back_link" onClick={() => { browserHistory.goBack() }}>
                      <a href="javascript:;"><i className="material-icons">arrow_back_ios_new</i></a> Back
                    </div>
                  ) : (
                    <ul className="header progress-bar inline">{items}</ul>
                  )}
                  {/* {!hasShopService &&
                    (currentIndex > 0) && (
                      <div className="back_link" onClick={() => { breadCrumbClick(labelConversion[names[currentIndex - 1]].pathEnd, currentIndex - 1, 0); }}>
                        <a href="javascript:;"><i className="material-icons">arrow_back_ios_new</i></a> Back to {names[currentIndex - 1]}
                      </div>
                    )} */}
                  <h3 className='service-title-text'>{h1}</h3>
                </>
              );

            }
            // If screen width <= 300px
            if (!hideBreadcrumbs && currentIndex > 0) {
              const prevIndex = currentIndex > 0 ? currentIndex - 1 : -1;
              const prevPath = labelConversion[names[prevIndex]].pathEnd;
              return (
                <>
                  <button
                    type="button"
                    className="button-to-link abbreviated-breadcrumb"
                    onClick={() => {
                      breadCrumbClick(prevPath, prevIndex, 0);
                    }}
                  >
                    &#8249; {labelConversion[names[prevIndex]].abbrBreadcrumb}
                  </button>
                  <h3>{h1}</h3>
                </>
              );
            }
            return <h3>{h1}</h3>;
          }}
        </MediaQuery>
        <Row className="marginBottom0">
          <Col s={12} m={8}>
            <h5 className={!!h1 && !!h2 && 'subtext'}>{h2}</h5>
          </Col>
        </Row>
      </div>
    );

    return (
      <Zippity containerId="pricing" active="pricing">
        <ReferrerDebugger />
        <div className="grey-splash row">
          {referrer.code && (
            <div
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #e0cdcc',
                padding: '.25em 1em',
                borderRadius: '.5em',
                fontWeight: '800',
              }}
            >
              <p>
                <span style={{ color: '#d74742' }}>
                  REFERRAL DISCOUNT APPLIED |
                </span>{' '}
                Additional 20% Off All Service Packages
              </p>
            </div>
          )}

          {content}

          {hideYourCar ? (
            <div className="col m12 white-splash">
              <div className="row">{children}</div>
              {showMotorAttribution && (
                <MotorAtttribution make={vehicle.make} />
              )}
            </div>
          ) : (
            <div>
              <div className="col m12 s12 white-splash calendar-responsive marginBottom0">
                <div className="row marginBottom0">{children}</div>
                {showMotorAttribution && (
                  <MotorAtttribution make={vehicle.make} />
                )}
                {bannerData && (
                  <MarketingBanner
                    bannerData={bannerData}
                    my_simple_shop_url={my_simple_shop_url}
                    addXLToImageUrl={this.addXLToImageUrl}
                    z3p_client_name={z3p_client_name}
                    services={cartServices}
                  />
                )}
              </div>
              {/* <YourCar
                onContinue={onContinue}
                showContinue={showContinue}
                enableContinue={enableContinue}
                alertText={alertText}
              /> */}

            </div>
          )}
        </div>
      </Zippity>
    );
  }
}

function mapStateToProps(state) {
  return {
    referrer: state.ui.referrer,
    cart: state.ui.cart,
    vehicle: state.ui.pricing,
    clientLocations: state.ui.clientLocations,
    z3pConfiguration: state.ui.z3pConfiguration,
  };
}

export default connect(mapStateToProps, null)(Pricing);